import { cn } from "@gigpro/ui/tailwind/cn";
import React from "react";

const rooftops =
  "M0 20 V13 H18 V10 H21 V13 H40 V15 H44 L56 6 L68 15 H74 V11 H96 V8 H99 V11 H104 V14 H130 V9 L136 4 L142 9 V14 H150 V16 H176 V12 L188 5 L200 12 V16 H214 V10 H240 V7 H243 V10 H252 V14 H270 L280 8 L290 14 H300 V17 H326 V11 H346 V7 L350.5 0.5 L355 7 V11 H372 V15 H390 L402 7 L414 15 H420 V12 H446 V9 H449 V12 H468 V16 H490 V10 L497 6 L504 10 V16 H520 V13 H544 V10 H547 V13 H560 L572 6 L584 13 H600 V20 Z";

const windows = [
  [55, 11.5],
  [116, 16],
  [187, 10],
  [349.5, 8],
  [432, 14.5],
  [571, 10.5],
] as const;

type HeaderSkylineProps = {
  className?: string;
  /** Scales the 20px tile down to 15px for the shorter mobile bar. */
  compact?: boolean;
};

/** A faint rooftop silhouette tiled along the bottom of a nav bar. */
export const HeaderSkyline = ({ className, compact = false }: HeaderSkylineProps) => {
  // useId can contain characters that break a `url(#…)` reference.
  const id = `skyline-${React.useId().replaceAll(/[^\w-]/g, "")}`;
  return (
    <svg aria-hidden="true" className={cn("pointer-events-none absolute inset-x-0 bottom-0 w-full", className)}>
      <defs>
        <pattern
          id={id}
          width="600"
          height="20"
          patternUnits="userSpaceOnUse"
          patternTransform={compact ? "scale(0.75)" : undefined}
        >
          {/* The shorter mobile tile needs a little more contrast to read as rooftops. */}
          <path d={rooftops} className={compact ? "fill-white/20" : "fill-white/15"} />
          {windows.map(([x, y]) => (
            <rect key={x} x={x} y={y} width="2" height="2.5" className="fill-warning/70" />
          ))}
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
};
